'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * String key that carries API call info interpreted by this Redux middleware.
 *
 * @constant {string}
 * @access public
 * @default
 */
var RSAA = '@@redux-api-middleware/RSAA';

exports.default = RSAA;


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/lib/RSAA.js
// module id = 197
// module chunks = 0